import { chakra, Flex, Text } from "@chakra-ui/react";

export const StyledDeletePopupContainer = chakra(Flex, {
  baseStyle: {
    flexDir: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    py: "16px",
  },
});

export const CheckYourEmailTopHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "700",
    fontSize: { base: "24px", md: "28.42px" },
    marginTop: { base: "24px", md: "32px" },
    textAlign: "center",
  },
});

export const CheckYourEmailHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "32px" },
    marginTop: { base: "24px", md: "16px" },
    textAlign: "center",
  },
});

export const CheckYourEmailDesc1 = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "16px" },
    textAlign: "center",
    color: "primary.grayText",
    marginTop: "16px",
  },
});

export const CheckYourEmailDesc2 = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "16px" },
    textAlign: "center",
    color: "primary.grayText",
    marginTop: "16px",
    px: "12px",
  },
});
